export const reportDWHBuilder = (mode, params) => {
  let report;
  switch (mode) {
    case 'SHOWPAGE':
      report = {
        subArea: 'BusinessSimReplacement',
        actionType: 'SIM replacement search page',
        status: 'Ongoing',
        messageText: 'Subscriber Search Page Displayed',
        param1: params?.param1,
      };
      break;
    case 'BUTTON_CLICK':
      report = {
        subArea: 'BusinessSimReplacement',
        actionType: 'SIM replacement search page',
        status: 'Ongoing',
        messageText: 'Subscriber Search Page Button Clicked',
        param1: params?.param1,
        param2: params?.param2,
        param10: params?.param10,
      };
      break;
    case 'SUB_DIFF_ORG':
      report = {
        subArea: 'BusinessSimReplacement',
        actionType: 'SIM replacement search page',
        status: 'Ongoing',
        messageText: 'Subscriber associated with another business account',
        param1: params?.param1,
        param2: params?.param2,
        param10: params?.param10,
      };
      break;
    case 'GEN_ERR':
      report = {
        subArea: 'BusinessSimReplacement',
        actionType: 'SIM replacement search page',
        status: 'Error',
        messageText: 'General Error',
        param1: params?.param1,
        param2: params?.param2,
        param10: params?.param10,
      };
      break;
    case 'SUB_NOT_FOUND':
      report = {
        subArea: 'BusinessSimReplacement',
        actionType: 'SIM replacement search page',
        status: 'Completed',
        messageText: 'Subscriber Not Found',
        param1: params?.param1,
        param2: params?.param2,
        param10: params?.param10,
      };
      break;
    case 'SUCCESS':
      report = {
        subArea: 'BusinessSimReplacement',
        actionType: 'SIM replacement search page',
        status: 'Completed',
        messageText: 'Success',
        param1: params?.param1,
        param2: params?.param2,
        param10: params?.param10,
        businessDetails: {_subscriber: params?.param10},
      };
      break;
  }
  return report;
};
